export default [
  {
    path: '/digital-mail/restrictions',
    name: 'digital-mail-restrictions',
    component: () => import('@/views/digitalMailRestrictions/DigitalMailRestrictions.vue'),
    meta: {
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      protected: true,
      pageTitle: 'Prisoner Bans',
      breadcrumb: [
        {
          text: 'Prisoner Bans',
          active: true,
        },
      ],
    },
  },
]
